import { gql } from '@apollo/client'

export const SAVE_GUIDE_HOLES_MUTATION = gql`
  mutation SaveGuideHoles($saveGuideHolesInput: [GuideHoleInput]!, $guideId: ID!) {
    GuidesMutation {
      saveGuideHoles(saveGuideHolesInput: $saveGuideHolesInput, guideId: $guideId)
    }
  }
`

export const GET_CLUB_GUIDES_QUERY = gql`
  query GetClubGuides($clubId: ID!) {
    GuidesQuery {
      clubGuides(clubId: $clubId)
    }
  }
`